import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import { BrowserRouter } from "react-router-dom";

ReactDOM.render(
  <BrowserRouter>
    <div class="powr-hit-counter" id="32994312_1680640612"></div>
    <script src="https://www.powr.io/powr.js?platform=react"></script>
    <App />
  </BrowserRouter>,
  document.getElementById("root")
);
